import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseRemoveFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.375 4.5H18H15.5V4C15.5 2.61929 14.3807 1.5 13 1.5H11C9.61929 1.5 8.5 2.61929 8.5 4V4.5H6H3.625C2.86561 4.5 2.25 5.11561 2.25 5.875C2.25 6.63439 2.86561 7.25 3.625 7.25H4.5H19.5H20.375C21.1344 7.25 21.75 6.63439 21.75 5.875C21.75 5.11561 21.1344 4.5 20.375 4.5ZM10 4.5H14V4C14 3.44772 13.5523 3 13 3H11C10.4477 3 10 3.44772 10 4V4.5ZM4.5 8.75V19C4.5 20.933 6.067 22.5 8 22.5H16C17.933 22.5 19.5 20.933 19.5 19V8.75H4.5ZM10.75 13C10.75 12.5858 10.4142 12.25 10 12.25C9.58579 12.25 9.25 12.5858 9.25 13V18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18V13ZM14.75 13C14.75 12.5858 14.4142 12.25 14 12.25C13.5858 12.25 13.25 12.5858 13.25 13V18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18V13Z"
        fill={color}
      />
    </svg>
  );
};
